import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './components/About';
import UserHome from './components/User/UserHome';
import Home from "./components/Home";
import Login from "./components/Login/Login";
import Terms from './components/Terms';
import NotFound from "./components/NotFound";
import ConditionalHeader from "./components/Header";
import { UserProvider } from "./context/UserContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";
import "./i18n/config";
import AnalyticsTracker from './components/AnalyticsTracker';
import PrivacyPolicy from './components/PrivacyPolicy'
import Volunteers from './components/Volunteers';
import OurStory from './components/OurStory';
import HostagePage from "./components/Hostage/HostagePage";
import ConfirmEmail from './components/Login/ConfirmEmail';
import LandingPage from "./components/LandingPage";
import ActivityPage from './components/Activity/ActivityPage';
import PrivacyPolicyEn from './components/PrivacyPolicyEn';
import TermsEn from './components/TermsEn';
import Admin from "./components/Admin/Admin";
import UnsubscribePage from './components/UnsubscribePage';


function App() {
  const [headerVisible, setHeaderVisible] = useState(true);

  return (
    <UserProvider>
      <div className="App">
        <CssBaseline />
        <Router>
          <AnalyticsTracker />
          <div>
            <ConditionalHeader setHeaderVisible={setHeaderVisible} />
            <div style={{ paddingTop: headerVisible ? "56px" : "0" }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/confirm-email" element={<ConfirmEmail />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/terms-en" element={<TermsEn />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/privacy-policy-en" element={<PrivacyPolicyEn />} />
                <Route path="/volunteers" element={<Volunteers />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/welcome" element={<LandingPage />} />
                {/* Protected Routes */}
                <Route
                  path="/home"
                  element={
                    <ProtectedRoute>
                      <UserHome />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/hostage/:id"
                  element={
                    <ProtectedRoute>
                      <HostagePage />
                    </ProtectedRoute>
                  }
                />
                 <Route
                  path="/activity/:id"
                  element={
                    <ProtectedRoute>
                      <ActivityPage/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/unsubscribe"
                  element={
                    <ProtectedRoute>
                      <UnsubscribePage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/admin" element={<Admin />} />
                {/* Catch-all for undefined routes */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </Router>
      </div>
    </UserProvider>
  );
}

export default App;
